/*eslint-disable*/
import React, { useState } from 'react'
import { components } from 'react-select'

import Select from 'components/Select'
import CheckBox from 'components/Checkbox'
import Button from 'components/Button'

import { MenuOption, MenuListFooter, MenuListActions } from './components/MenuList/style'
import {
  LabelWrapper,
  Header,
  Footer,
  TwoStepMultiSelectContainer,
  FirstStepSelectWrapper,
  SecondStepSelectWrapper
} from './style'

const noOptionValue = 0
const yesOptionValue = 1

const yesOption = { label: 'Yes', value: yesOptionValue }
const noOption = { label: 'No', value: noOptionValue }
const firstStepOptions = [noOption, yesOption]

const selectAllValue = 0

const formatSecondStepOptions = (options, secondStepSelection) => {
  return options.map((option) => {
    const isChecked = !!secondStepSelection.find((seletedOption) => {
      return seletedOption.value === option.value
    })
    return {
      label: (
        <MenuOption>
          <CheckBox checked={isChecked} /> {option.label}
        </MenuOption>
      ),
      initialLabel: option.label,
      value: option.value
    }
  })
}

const SecondStepSingleValue = (secondStepSelection) => {
  return function SingleValue(props) {
    return (
      <components.SingleValue {...props}>
        {(() => {
          if (!secondStepSelection.length) {
            return <span>Select multiple options</span>
          }
          if (secondStepSelection.length === 1) {
            return <span>{secondStepSelection[0].initialLabel}</span>
          }

          if (secondStepSelection.length > 1) {
            return (
              <span>
                {secondStepSelection[0].initialLabel}, +{secondStepSelection.length - 1}
              </span>
            )
          }
        })()}
      </components.SingleValue>
    )
  }
}

const SecondStepMenuList = (secondStepSelection, cancelAction, doneAction) => {
  return function MenuList(props) {
    return (
      <div>
        <components.MenuList {...props} />
        <MenuListFooter>
          <span>{secondStepSelection.length} selected </span>
          <MenuListActions>
            <div style={{ marginRight: '16px' }}>
              <Button height="40px" marginTop="0px" onClick={cancelAction} type="secondary">
                Cancel
              </Button>
            </div>
            <Button height="40px" marginTop="0px" onClick={doneAction} type="primary">
              Apply
            </Button>
          </MenuListActions>
        </MenuListFooter>
      </div>
    )
  }
}

const TwoStepMultiSelectionDropdown = ({
  label,
  value = [],
  secondStepOptions = [],
  saveChanges,
  marginBottom = '0px',
  marginTop = '0px',
  disabled
}) => {
  const withSecondStep = !!secondStepOptions.length
  let initialSecondStepSelection = []

  if (withSecondStep) {
    initialSecondStepSelection = secondStepOptions
      .filter((option) => {
        return value?.includes(option.value)
      })
      .map((option) => {
        return { ...option, initialLabel: option.label }
      })
  }

  let firstStepSelectionInitial = noOption

  if (withSecondStep) {
    firstStepSelectionInitial = value?.length ? yesOption : noOption
  } else {
    firstStepSelectionInitial = value ? yesOption : noOption
  }

  const [firstStepSelection, setFirstStepSelection] = useState(firstStepSelectionInitial)
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const [secondStepSelection, setSecondStepSelection] = useState(initialSecondStepSelection)
  const secondStepOptionsFormatted = formatSecondStepOptions(secondStepOptions, secondStepSelection)
  const isAllOptionsAlreadyChecked = secondStepOptions.length === secondStepSelection.length

  const onFocusHandler = () => {
    setMenuIsOpen(true)
    if(disabled && menuIsOpen){
      setMenuIsOpen(false)
    }
  }

  const onBlurHandler = () => {
    setMenuIsOpen(false)
  }

  const cancelAction = (e) => {
    e.stopPropagation()
    setSecondStepSelection(initialSecondStepSelection)
    setMenuIsOpen(false)
  }

  const saveAction = (e) => {
    e.stopPropagation()
    saveChanges(secondStepSelection.map((option) => option.value))
    setMenuIsOpen(false)
  }

  return (
    <TwoStepMultiSelectContainer data-testid='test-twoStepMultiSelectContainer' marginBottom={marginBottom} marginTop={marginTop}>
      <Header data-test="criteria-box">
        <LabelWrapper>{label}</LabelWrapper>
        <FirstStepSelectWrapper>
          <Select
            marginBottom="0px"
            marginTop="0px"
            height="40px"
            twoStepWidth="250px"
            menuPlacement="auto"
            value={firstStepSelection}
            options={firstStepOptions}
            disabled={disabled}
            onChange={(e) => {
              setFirstStepSelection(e)
              if (withSecondStep) {
                if (e.value === noOptionValue) {
                  setSecondStepSelection([])
                  saveChanges([])
                }
              } else {
                saveChanges(!!e.value)
              }
            }}
          />
        </FirstStepSelectWrapper>
      </Header>

      {firstStepSelection.value === yesOptionValue && withSecondStep && (
        <Footer data-test="criteria-body">
          <div style={{ marginBottom: '16px', fontWeight: '500', marginLeft: '16px', lineHeight: '24px', fontSize: '14px' }}>Subcriteria</div>
          <SecondStepSelectWrapper>
            <div onClick={onFocusHandler}>
              <Select
                marginBottom="0px"
                paddingLeft='8px'
                closeMenuOnSelect={false}
                menuIsOpen={menuIsOpen}
                onFocus={onFocusHandler}
                onBlur={onBlurHandler}
                disabled={disabled}
                maxMenuHeight={200}
                singleValueComponent={SecondStepSingleValue(secondStepSelection)}
                menuListComponent={SecondStepMenuList(secondStepSelection, cancelAction, saveAction)}
                value={value.length ? { label: 'Yes', value: 1 } : { label: 'No', value: 0 }}
                options={[
                  {
                    label: (
                      <MenuOption>
                        <CheckBox checked={isAllOptionsAlreadyChecked} /> Select All
                      </MenuOption>
                    ),
                    value: selectAllValue
                  },
                  ...secondStepOptionsFormatted
                ]}
                onChange={(e) => {
                  const selectAllChecked = e.value === selectAllValue
                  if (selectAllChecked) {
                    setSecondStepSelection(isAllOptionsAlreadyChecked ? [] : secondStepOptionsFormatted)
                    return
                  }

                  const isSelectedOptionAlreadyChecked = !!secondStepSelection.find((option) => {
                    return option.value === e.value
                  })

                  setSecondStepSelection((s) => {
                    if (!isSelectedOptionAlreadyChecked) return [...s, e]

                    return s.filter((option) => {
                      return option.value !== e.value
                    })
                  })
                }}
              />
            </div>
          </SecondStepSelectWrapper>
        </Footer>
      )}
    </TwoStepMultiSelectContainer>
  )
}

export default TwoStepMultiSelectionDropdown
